import React, { useEffect } from 'react';
import { Link, useHistory } from "react-router-dom"
import { Helmet } from "react-helmet";

import FrontSiteNavbar from './FrontSiteNavbar';
import FrontSiteFooter from './FrontSiteFooter';

export default function SeoPageLayout(props) {
    const { title, description, keywords, linkOuter, children } = props

    //const history = useHistory()

    // useEffect(() => {
    //     const script = document.createElement('script');
    //     script.src = "./assets/js/animation.js";
    //     script.async = true;
    //     document.body.appendChild(script);
    //     return () => {
    //         document.body.removeChild(script);
    //     }
    // }, []);

    return (
        <React.Fragment>
            <Helmet>
                <title>{title}</title>
                <meta
                    name="description"
                    content={description}
                />
                <meta
                    name="keywords"
                    content={keywords}
                />
            </Helmet>

            <FrontSiteNavbar linkOuter={linkOuter} />
            <main id="content" role="main">
                <div className="gradient-x-overlay-sm-primary position-relative overflow-hidden">
                    <div className='bg-light overflow-hidden'>
                        <div className="container content-space-1 content-space-md-2" style={{ fontSize: "1rem", wordBreak: 'break-word' }}>
                            <div className='text-left'>
                                <div className='row'>
                                    <div className='col-md-12'>
                                        <div className="page-box seo-page-box">
                                            {children}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <FrontSiteFooter />
            </main>
        </React.Fragment>
    )
}
